import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import StatusBar from './StatusBar';
import Header from './Header';
import WelcomeScreen from './WelcomeScreen';
import Desktop from './Desktop';
// import Hero from './Hero';
// import Blogs from './Blogs';
import AppShell from './AppShell';
import SearchOverlay from './SearchOverlay';
// import Projects from './Projects';
import Certifications from './Certifications';
import Contact from './Contact';
// import { blogsData, projectsData, certificationsData } from '../data/contentData';
import { certificationsData } from '../data/contentData';
// import { FaGithub, FaLinkedin } from "react-icons/fa";
import GitHubView from './GitHubView';
import ProjectRouter from './projects/ProjectRouter';






// const ComingSoon = () => (
//   <motion.div
//     initial={{ opacity: 0, y: 20 }}
//     animate={{ opacity: 1, y: 0 }}
//     transition={{ duration: 0.5 }}
//     className="min-h-[60vh] flex flex-col items-center justify-center px-6"
//   >
//     <div className="text-8xl mb-8">🚧</div>
//     <h2 className="text-4xl font-bold text-pure-white mb-4">Coming Soon</h2>
//     <p className="text-gray-400 text-lg text-center max-w-md">
//       This section is under construction. Check back later for updates on achievements and activities!
//     </p>
//   </motion.div>
// );


const CVView = () => (
  <div className="min-h-[60vh] flex flex-col items-center justify-center px-6">
    <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-10 border border-white/10 text-center max-w-md">
      <div className="text-7xl mb-6">📄</div>
      <h3 className="text-2xl font-bold text-pure-white mb-3">Resume</h3>
      <p className="text-gray-400 mb-8">
        View or Download my Resume.
      </p>
      <a
        href="/CV.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block px-8 py-3 bg-apple-blue text-pure-white rounded-full font-semibold hover:bg-blue-600 transition-all duration-300 hover:scale-105"
      >
        Download CV
      </a>
    </div>
  </div>
);

// const GitHubView = () => (
//   <div className="min-h-[60vh] flex flex-col items-center justify-center px-6">
//     <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-10 border border-white/10 text-center max-w-md">
//       <div className="text-7xl mb-6">🐙</div>
//       <h3 className="text-2xl font-bold text-pure-white mb-3">GitHub Repositories</h3>
//       <p className="text-gray-400 mb-8">
//         Repo cards coming soon! Do check out my repo!
//       </p>
//       <a
//         href="https://github.com/niccolopaganini"
//         target="_blank"
//         rel="noopener noreferrer"
//         className="inline-block px-8 py-3 bg-white/10 text-pure-white rounded-full font-semibold hover:bg-white/20 transition-all duration-300 hover:scale-105 backdrop-blur-sm"
//       >
//         Visit GitHub Profile →
//       </a>
//     </div>
//   </div>
// );
 
const MLModelsView = () => (
  <div className="min-h-[60vh] flex flex-col items-center justify-center px-6">
    <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-10 border border-white/10 text-center max-w-md">
      <div className="text-7xl mb-6">🧠</div>
      <h3 className="text-2xl font-bold text-pure-white mb-3">ML Models</h3>
      <p className="text-gray-400">
        Technical deep-dives into model architectures, training metrics, and evaluation results (coming soon!)
      </p>
    </div>
  </div>
);
 
const ImpactStoriesView = () => (
  <div className="min-h-[60vh] flex flex-col items-center justify-center px-6">
    <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-10 border border-white/10 text-center max-w-md">
      <div className="text-7xl mb-6">📊</div>
      <h3 className="text-2xl font-bold text-pure-white mb-3">Impact Stories</h3>
      <p className="text-gray-400">
        Interactive case studies showcasing real-world impact (coming soon!)
      </p>
    </div>
  </div>
);

const APP_REGISTRY = {
  github:           { label: 'GitHub',          component: GitHubView },
  // 'ml-models':      { label: 'ML Models',       component: MLModelsView },
  'ml-models':      { label: 'Projects',       component: null },
  cv:               { label: 'CV',              component: CVView },
  certifications:   { label: 'Certifications',  component: null },
  contact:          { label: 'Contact',         component: Contact },
  'impact-stories': { label: 'Case Studies',  component: null },

  // 'impact-stories': { label: 'Impact Stories',  component: ImpactStoriesView },
};


const MainLayout = ({ persona, onSwitchPersona, onLock }) => {
  const [showWelcome, setShowWelcome] = useState(true);
  const [activeApp, setActiveApp] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  // const [filteredContent, setFilteredContent] = useState({
  //   // blogs: blogsData,
  //   // projects: projectsData,
  //   certifications: certificationsData,
  // });

  const handleOpenApp = (appId) => {
    if (appId === 'linkedin') {
      window.open('https://www.linkedin.com/in/nvsr0210', '_blank', 'noopener,noreferrer');
      return;
    }
    setActiveApp(appId);
  };

  const handleCloseApp = () => {
    setActiveApp(null);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
  };


  // useEffect(() => {
  //   if (searchQuery.trim() === '') {
  //     setFilteredContent({
  //       // blogs: blogsData,
  //       // projects: projectsData,
  //       certifications: certificationsData,
  //     });
  //   } else {
  //     const query = searchQuery.toLowerCase();
  //     setFilteredContent({
  //       // blogs: blogsData.filter(
  //       //   (blog) =>
  //       //     blog.title.toLowerCase().includes(query) ||
  //       //     blog.excerpt.toLowerCase().includes(query) ||
  //       //     blog.content.toLowerCase().includes(query)
  //       // ),
  //       // projects: projectsData.filter(
  //       //   (project) =>
  //       //     project.title.toLowerCase().includes(query) ||
  //       //     project.description.toLowerCase().includes(query)
  //       // ),
  //       certifications: certificationsData.filter(
  //         (cert) =>
  //           cert.title.toLowerCase().includes(query) ||
  //           cert.issuer.toLowerCase().includes(query)
  //       ),
  //     });
  //   }
  // }, [searchQuery]);

  const renderAppContent = () => {
    if (!activeApp) return null;

    // Certifications needs filtered data as props
    if (activeApp === 'certifications') {
      return <Certifications certifications={certificationsData} />;
    }
    if (activeApp === 'ml-models') {
      return <ProjectRouter persona="developer" />;
    }
    if (activeApp === 'impact-stories') {
      return <ProjectRouter persona="recruiter" />;
    }
    const app = APP_REGISTRY[activeApp];
    if (app?.component) {
      const Component = app.component;
      return <Component />;
    }
    return null;
  };

  const getAppLabel = () => APP_REGISTRY[activeApp]?.label || '';

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-pure-black"
    >

      {/* Welcome Screen — plays once, nothing else renders until it's done */}
      {showWelcome ? (
        <WelcomeScreen
          persona={persona}
          onComplete={() => setShowWelcome(false)}
        />

      ) : (
        <>
          <StatusBar persona={persona} />

          <Header onSearch={setSearchQuery} searchQuery={searchQuery} persona={persona} onSwitchPersona={onSwitchPersona} onLock={onLock} />

          <SearchOverlay
            query={searchQuery}
            persona={persona}
            onOpenApp={(appId) => {
              handleOpenApp(appId);
              handleClearSearch();
            }}
            onClose={handleClearSearch}
          />

          <Desktop persona={persona} onOpenApp={handleOpenApp} />

          <AnimatePresence>
            {activeApp && (
              <AppShell
                appId={activeApp}
                appLabel={getAppLabel()}
                onClose={handleCloseApp}
              >
                {renderAppContent()}
              </AppShell>
            )}
          </AnimatePresence>
        </>
      )}
    </motion.div>
  );
};
 


  // Render content based on user
//   const rendetrContent = () => {
//     switch (persona) {
//       case 'developer':
//         return (
//           <>
//             {/* <div id="blogs">
//               <Blogs blogs={filteredContent.blogs} />
//             </div> */}
//             <div id="projects">
//               <Projects projects={filteredContent.projects} />
//             </div>
//             <div id="certifications">
//               <Certifications certifications={filteredContent.certifications} />
//             </div>
//             <div id="contact">
//               <Contact />
//             </div>
//           </>
//         );

//       case 'recruiter':
//         return (
//           <>
//             <div id="certifications">
//               <Certifications certifications={filteredContent.certifications} />
//             </div>
//             <div id="contact">
//               <Contact />
//             </div>
//           </>
//         );

//       case 'athlete':
//         return <ComingSoon />;

//       default:
//         return null;
//     }
//   };

//   return (
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       exit={{ opacity: 0 }}
//       transition={{ duration: 0.5 }}
//       className="min-h-screen bg-pure-black"
//     >
//       {/* Status Bar — sits at the very top */}
//       <StatusBar persona={persona} />

//       <Header onSearch={setSearchQuery} searchQuery={searchQuery} />
      
//       <Hero persona={persona} />

//       {renderContent()}
//     </motion.div>
//   );
// };

export default MainLayout;
